export const oidcConfig = {
    authority: process.env.REACT_APP_AUTH_AUTHORITY,
    client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_AUTH_REDIRECT_URI,
    response_type: process.env.REACT_APP_AUTH_RESPONSE_TYPE,
    scope: process.env.REACT_APP_AUTH_SCOPE,
    post_logout_redirect_uri: process.env.REACT_APP_AUTH_POST_LOGOUT_REDIRECT_URI
};